import { clamp } from "./format";

// Seek bar: hover preview, drag-to-scrub, and keyboard on the range input.
export function bindProgress(player) {
    const { el, cfg, state, render, actions } = player;
    const isRtl = getComputedStyle(el.progress).direction === "rtl";

    function pointerTime(e) {
        const rect = el.progress.getBoundingClientRect();
        if (rect.width <= 0 || state.duration <= 0) return 0;
        const ratio = (e.clientX - rect.left) / rect.width;
        const logical = isRtl ? 1 - ratio : ratio;
        return clamp(logical * state.duration, 0, state.duration);
    }
    function updateHover(e) {
        if (player.isSeekDisabled()) return;
        state.hoverTime = pointerTime(e);
        render();
    }
    function commitSeek(time) {
        state.scrubTime = null;
        actions.seek(time);
    }

    el.progress.addEventListener("mouseenter", e => {
        state.isHovered = true;
        updateHover(e);
    });
    el.progress.addEventListener("mousemove", updateHover);
    el.progress.addEventListener("mouseleave", e => {
        if (e.relatedTarget instanceof Node && el.progress.contains(e.relatedTarget)) return;
        state.isHovered = false; // keep hoverTime so the preview fades out in place
        render();
    });

    el.seek.addEventListener("input", () => {
        const next = Number(el.seek.value);
        if (state.isDragging) {
            state.scrubTime = next;
            render();
        } else {
            commitSeek(next);
        }
    });
    el.seek.addEventListener("pointerdown", e => {
        state.isDragging = true;
        updateHover(e);
    });
    el.seek.addEventListener("pointermove", updateHover);
    el.seek.addEventListener("pointerup", () => {
        state.isDragging = false;
        if (state.scrubTime !== null) commitSeek(state.scrubTime);
        else render();
    });
    el.seek.addEventListener("pointercancel", () => {
        state.isDragging = false;
        state.scrubTime = null;
        render();
    });
    el.seek.addEventListener("focus", () => {
        state.isFocused = true;
        render();
    });
    el.seek.addEventListener("blur", () => {
        state.isFocused = false;
        render();
    });
    el.seek.addEventListener("keydown", e => {
        if (player.isSeekDisabled()) return;
        const skipBy = secs => {
            e.preventDefault();
            state.scrubTime = null;
            actions.skip(secs);
        };
        if (e.key === "ArrowLeft") skipBy(-cfg.skip);
        else if (e.key === "ArrowRight") skipBy(cfg.skip);
        else if (e.key === "Home") {
            e.preventDefault();
            commitSeek(0);
        } else if (e.key === "End") {
            e.preventDefault();
            commitSeek(state.duration);
        }
    });
}
